var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCommentModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1293_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.333 25.083H71.6663",
    stroke: "#DC4039",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.833 39.417V60.917",
    stroke: "#DC4039",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.167 39.417V60.917",
    stroke: "#DC4039",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 30L21.5714 68.5714C21.5714 70.2764 22.324 71.9115 23.6635 73.1171C25.0031 74.3227 26.8199 75 28.7143 75H57.2857C59.1801 75 60.9969 74.3227 62.3365 73.1171C63.676 71.9115 64.4286 70.2764 64.4286 68.5714L68 30",
    stroke: "#DC4039",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20V13.25C32 12.6533 32.3863 12.081 33.0739 11.659C33.7616 11.2371 34.6942 11 35.6667 11H50.3333C51.3058 11 52.2384 11.2371 52.9261 11.659C53.6137 12.081 54 12.6533 54 13.25V20",
    stroke: "#DC4039",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1293_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCommentModal);
export default __webpack_public_path__ + "static/media/deleteCommentModal.cb63619f3aecb26b2f51c879ae5bfb95.svg";
export { ForwardRef as ReactComponent };